import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCreditCard = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M0.833496 8.33337H19.1668M2.50016 3.33337H17.5002C18.4206 3.33337 19.1668 4.07957 19.1668 5.00004V15C19.1668 15.9205 18.4206 16.6667 17.5002 16.6667H2.50016C1.57969 16.6667 0.833496 15.9205 0.833496 15V5.00004C0.833496 4.07957 1.57969 3.33337 2.50016 3.33337Z",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgCreditCard;
